import React, { FunctionComponent } from 'react';
import { Investor, LegalPerson, NaturalPerson } from 'api/models';
import BoxedContent from 'ui/molecules/boxed-content';
import { extractNaturalAndLegalFromPerson } from 'core/api/conversions';
import { PersonType } from 'ui/types/person';
import useUserData from './use-user-data';
import InvestorUserInformation from './user-information';
import { UserDataSet } from 'ui/types/user-data-set';
import Translate from 'ui/atoms/translate';
import ActionButtons from 'src/ui/molecules/action-buttons';
import Button from 'ui/atoms/button';
import useEditInvestorData from 'hooks/use-edit-investor-data';
import InvestorEditModals from '../edit-modals';

interface UserDataViewProps {
  investor: Investor;
  fetchInvestorDetails: () => void;
}

const UserDataView: FunctionComponent<UserDataViewProps> = (props) => {
  const { investor, fetchInvestorDetails } = props;

  const investorDataProps = useEditInvestorData();

  const { naturalPerson, legalPerson } = extractNaturalAndLegalFromPerson(investor?.person);

  const rootPerson = investor?.person.personType === PersonType.Legal ? legalPerson : naturalPerson;

  const userSections = useUserData({ ...investorDataProps, rootPerson, naturalPerson, legalPerson });

  return (
    <>
      {userSections.map((userDataSet, index) => {
        if (!userDataSet) {
          return null;
        }

        const editButtons = userDataSet.editButtons;

        return (
          <BoxedContent
            title={<Translate name={`dashboardInvestorSettings.${userDataSet.key}.title`} />}
            releaseSpaceWhenTitleIsEmpty={true}
            key={index}
          >
            <InvestorUserInformation
              userDataSet={userDataSet as UserDataSet}
              userType={'investor'}
              personType={investor?.person.personType as any} // TODO(mara-cashlink): replace any
              naturalPerson={naturalPerson as any} // TODO(mara-cashlink): replace any
              legalPerson={legalPerson as any} // TODO(mara-cashlink): replace any
            />
            <ActionButtons verticalAlign>
              {editButtons.map(
                (editInfo) =>
                  editInfo.display && (
                    <Button variant="secondary" onClick={() => editInfo.onClick()}>
                      <Translate name={editInfo.text} />
                    </Button>
                  ),
              )}
            </ActionButtons>
          </BoxedContent>
        );
      })}
      <InvestorEditModals
        id={investor?.id || ''}
        rootPerson={rootPerson as NaturalPerson | LegalPerson}
        fetchInvestorDetails={fetchInvestorDetails}
        {...investorDataProps}
      />
    </>
  );
};

export default UserDataView;
